import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import { AnualCalendarMonth } from '@app/entities/models/lababs/lababs-vacations.model';
import {
  FactoryManageVacationsProposals,
  FactoryCompensation
} from '@app/entities/models/manage-vacations/factory-manage-vacations.model';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import {
  EmployeeObservations,
  SeasonCalendar,
  VacationsSeason
} from '@app/entities/models/manage-vacations/manage-vacations.model';
import { MotFactoryProposal } from '@app/entities/models/manage-vacations/mot-manage-vacations.model';

import { TUserTypeCalendarProposal } from '@/types/manage-vacations.type';

export interface FactoryManageVacationsRepository {
  getProposals(): Observable<FactoryManageVacationsProposals>;
  getVacationsCriteria(): Observable<ManageVacationsCriteria>;
  getVacationsSeason(): Observable<VacationsSeason>;
  getSeasonCalendar(season: SEASONS): Observable<SeasonCalendar<TUserTypeCalendarProposal>>;
  createProposal(
    proposals: FactoryManageVacationsProposals,
    storedProposals: MotFactoryProposal[],
    isSummerSeason: boolean
  ): Observable<FactoryManageVacationsProposals>;
  updateObservations(observations: string): Observable<EmployeeObservations>;
  getCompensations(): Observable<FactoryCompensation>;
  getCalendar(): Observable<AnualCalendarMonth[]>;
  createCompensation(compensations: FactoryCompensation): Observable<FactoryCompensation>;
}
export const FACTORY_MANAGE_VACATIONS_REPOSITORY = new InjectionToken<FactoryManageVacationsRepository>(
  'FACTORY_MANAGE_VACATIONS_REPOSITORY'
);
